import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=2838d8a8"
import script from "./profile.vue?vue&type=script&setup=true&lang=ts"
export * from "./profile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports